import { logError } from "common/error";
import { Sound as CommonSound } from "common/sound";
import * as R from "ramda";
export const soundName = encodeURIComponent("오디오 소스.m4a");
export async function loadSound(src) {
    try {
        return await CommonSound.load({
            sheetPath: src,
            sprite: spritesForHowler,
            loopNameMapper,
        });
    }
    catch (e) {
        logError(e);
        throw e;
    }
}
const loopNameMapper = (loopName) => {
    switch (loopName) {
        case "runningGrandpas":
            return ["runningGrandpas"];
    }
};
const sprites = {
    opening: { start: 0, end: 1 + 12 / 30 },
    announcement1: { start: 1 + 21 / 30, end: 3 + 16 / 30 },
    background1: { start: 3 + 19 / 30, end: 4 + 13 / 30 },
    background2: { start: 4 + 13 / 30, end: 5 + 7 / 30 },
    heart: { start: 5 + 7 / 30, end: 5 + 24 / 30 },
    background3: { start: 5 + 28 / 30, end: 6 + 1 / 30 },
    background4: { start: 6 + 4 / 30, end: 6 + 10 / 30 },
    background5: { start: 6 + 21 / 30, end: 8 + 9 / 30 },
    grandpaSaying1: { start: 8 + 19 / 30, end: 10 + 7 / 30 },
    grandpaSaying2: { start: 10 + 14 / 30, end: 11 + 4 / 30 },
    grandpaSaying3: { start: 11 + 13 / 30, end: 13 + 12 / 30 },
    runningGrandpas: { start: 13 + 17 / 30, end: 15 + 26 / 30 },
};
export const spritesDurations = R.map(({ start, end }) => end * 1000 - start * 1000, sprites);
const spritesForHowler = R.map(({ start, end }) => [
    Math.floor(start * 1000),
    Math.floor(end * 1000 - start * 1000),
], sprites);
//# sourceMappingURL=sound.js.map